<template>
  <v-dialog
    ref="dialog"
    v-model="menu"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="click-icon">
        <v-icon small>far fa-calendar-day</v-icon>
      </div>
    </template>
    <v-date-picker
      v-model="date"
      scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false"> {{$vuetify.lang.t('$vuetify.DatepickerCustom.btnCancel')}} </v-btn>
      <v-btn text color="primary" @click="clickOk()"> {{$vuetify.lang.t('$vuetify.DatepickerCustom.btnOk')}} </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
export default {
    name: 'CustomDatePicker',
    props: {
        value: String,
        disableFutureDate: Boolean
    },
    data: function () {
        return {
            menu: false,
            modal: false,
            date: null
        }
    },
    computed: {
        dateRangeText: function () {
            return this.formatDate(this.date)
        }
    },
    created: function () {
        this.date = this.value
    },
    methods: {
        clickOk: function () {
            this.$refs.dialog.save(this.date)
            this.$emit('input', this.date)
            this.$emit('onChangeDate', this.date)
        },
        formatDate: function (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/color.scss';
.click-icon {
    display: flex;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 5px;
    border: 1px solid $base-grey;
}
</style>
